import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterBannerComponent } from './components/filter-banner/filter-banner.component';
import { FilterContainerComponent } from './components/filter-container/filter-container.component';
import { ResetFilterContainerComponent } from './components/reset-filter-container/reset-filter-container.component';
import { IconComponent } from '@ui/shared/ui-common';
import { ButtonModule } from 'primeng/button';
import { FocusTrapModule } from 'primeng/focustrap';

@NgModule({
    declarations: [
        FilterBannerComponent,
        FilterContainerComponent,
        ResetFilterContainerComponent,
    ],
    imports: [
        CommonModule,
        ButtonModule,
        FocusTrapModule,

        IconComponent,
    ],
    exports: [
        FilterContainerComponent,
    ],
})
export class FilterContainerModule { }
